const defaultConfig = {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
    attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
    default: false,
    name: 'Arcgis Satélite',
    minZoom: 4,
    maxNativeZoom: 17,
    maxZoom: 17
};

export default defaultConfig;
